import { ColumnModel } from 'neo-table-lib';

export const getColumnObject = function (columObj) {
  let object = new ColumnModel();
  Object.keys(object).forEach((key) => {
    if (!columObj.hasOwnProperty(key)) {
      columObj[key] = object[key];
    }
  });
  return columObj;
};

export const getColumnExists = function (columns, colKey) {
  return Object.keys(columns).some(function (column) {
    return columns[column].colKey === colKey;
  });
};
